import { cn } from '@ifixit/ui/lib/utils';
import type { ComponentProps } from 'react';

/**
 * The page root shared by the editors (guide, new guide, guide translate,
 * wiki, wiki translate), so they stay one width: a guide links to its
 * translate page and a device page to its editor, and a page that narrows on
 * the way reads as a different place. 1280px is what the step card needs for
 * its photo and lines columns (StepEditor) and what the translate pages use
 * for their source and target columns; the cards cap their forms and lists
 * inside (max-w-3xl), so the page only gets wider where that helps. Below md
 * the cards go full-bleed (SectionCard drops its corners and side borders),
 * so the root carries no horizontal padding there; rows that aren't cards pad
 * themselves back to 16px.
 */
export function EditorPage({ className, ...props }: ComponentProps<'div'>) {
   return <div className={cn('mx-auto w-full max-w-7xl pb-8 md:px-8', className)} {...props} />;
}
